import { memo, type PropsWithChildren } from 'react';

import { useFlag } from '../../services/launchDarkly';
import type { LDFlags } from '../../services/types';

export const FeatureFlag = memo(function FeatureFlag({
  flagKey,
  defaultValue,
  children,
}: PropsWithChildren<{ flagKey: LDFlags; defaultValue: boolean }>) {
  const featureFlag = useFlag(flagKey, defaultValue);

  if (!featureFlag) {
    return null;
  } else {
    return children;
  }
});
